<script>
export default {
  name: 'ExitStationButton',
  methods: {
    onExit() {
      this.$emit('stationExited');
    }
  }
};
</script>

<template>
  <button class="exit" v-on:click="onExit()">
    {{$t('player.exitStation')}}
  </button>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';

.exit {
  position: relative;
  padding: 0 1.5rem;
  margin: 0;
  background: var(--light);
  font-family: var(--font-family-primary);
  font-size: 1.5rem;
  white-space: nowrap;
  color: var(--dark);
  border: none;
  line-height: 1;
  height: 3rem;
  line-height: 3rem;
}

</style>
